import classNames from "classnames";
import { MatchGauge } from "PFComponents/resource_metrics/match_gauge";
import { IconName } from "PFTheme/graphics/icons";
import { CustomTypes, MatchedProfile } from "PFTypes";
import { ComponentProps, MouseEvent, ReactElement, ReactNode, SyntheticEvent, useCallback } from "react";

import { Card } from "../card";
import { ProfileCardActionsRow } from "./parts/profile_card_actions_row";
import ProfileCardSkills from "./parts/profile_card_skills";
import ProfileCardTitle from "./parts/profile_card_title";
import { ProfileCardTopRightCorner } from "./parts/profile_card_top_right_corner";
import css from "./profile_card.module.scss";

const AVATAR_SIZE = 80;

type GaugeProps = Partial<Omit<ComponentProps<typeof MatchGauge>, "match">>;

export type ProfileCardProps = {
  className?: string;
  customTypes: CustomTypes;
  profileResponse: MatchedProfile;
  actions?: ReactNode;
  headerActions?: ReactNode;
  embeded?: boolean;
  topRightCornerNode?: ReactNode;
  children?: ReactElement;
  footer?: ReactElement;
  icon?: IconName;
  isColumn?: boolean;
  handleClick?: () => void;
  handleIconClick?: (e: SyntheticEvent) => void;
  gaugeProps?: GaugeProps;
  // makes profiles names hashed and avatar blank for fair-recruitement reasons
  isUnbiasedMode: boolean;
};

/**
 * @deprecated Use application\components\profile_card
 */
export const ProfileCard = ({
  className,
  customTypes,
  profileResponse,
  actions,
  headerActions,
  embeded,
  topRightCornerNode,
  children,
  footer,
  icon,
  isColumn,
  handleClick,
  handleIconClick,
  isUnbiasedMode,
  gaugeProps = {}
}: ProfileCardProps) => {
  const { profile, scores } = profileResponse;
  const skillsStyle = embeded ? { borderTop: 0 } : {};

  const href = `/profiles/${profile.id}`;

  const onAvatarClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      handleClick?.();
    },
    [handleClick]
  );

  const guts = (
    <>
      <div className={css.header}>
        <ProfileCardTitle
          avatarSize={AVATAR_SIZE}
          customTypes={customTypes}
          handleClick={handleClick}
          handleIconClick={handleIconClick}
          href={href}
          icon={icon}
          isUnbiasedMode={isUnbiasedMode}
          profile={profile}
          onAvatarClick={onAvatarClick}
        />

        <ProfileCardTopRightCorner
          scores={scores}
          headerActions={headerActions}
          topRightCornerNode={topRightCornerNode}
          gaugeProps={gaugeProps}
        />
      </div>

      <ProfileCardSkills
        profileResponse={profileResponse}
        style={skillsStyle}
        isUnbiasedMode={isUnbiasedMode}
      />

      {children}

      <ProfileCardActionsRow actions={actions} isColumn={isColumn} />

      {footer}
    </>
  );

  return embeded ? (
    <div className={classNames(css.embededWrap, className)}>{guts}</div>
  ) : (
    <Card className={className} paddingVariant="lg">
      {guts}
    </Card>
  );
};
